<template>
  <v-card class="post-item app-card radius-always my-1 pa-3" :to="relatedRoute">
    <div class="d-flex gap-3">
      <post-list-item-thumbnail :post="post" class="flex-shrink-0" />
      <div class="d-flex flex-column">
        <user-profile-link :user-id="post.author.id" class="font-size-big font-weight-bold" :class="{ 'font-size-title-small': $vuetify.display.mobile }">
          <div>{{ post.author.display_name }}</div>
        </user-profile-link>
        <post-list-item-where-posted :post="post" skip-author-if-no-content />
      </div>
    </div>
    <div class="truncate-multiline-1 font-size-big mt-2" :class="{ 'font-size-title-small': $vuetify.display.mobile }">
      <post-list-item-content :post="post" />
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "pinia"

import { useGroupsStore } from "@/store/groups.js"

import PostListItemThumbnail from "@/components/postables/post-lists/PostListItemThumbnail.vue"
import PostListItemContent from "@/components/postables/post-lists/PostListItemContent.vue"
import PostListItemWherePosted from "@/components/postables/post-lists/PostListItemWherePosted.vue"

export default {
  components: {
    PostListItemThumbnail,
    PostListItemContent,
    PostListItemWherePosted
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(useGroupsStore, ["isUserMember"]),
    relatedRoute() {
      if (this.isUserMember(this.post.wall)) {
        return {
          name: this.$routes.POST,
          params: {
            postId: this.post.id
          }
        }
      }

      return {
        name: this.$routes.GROUPS,
        params: {
          groupId: this.post.wall
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.post-item {
  width: 240px;
  height: 120px;
}
</style>
